// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2imVX","newExpiryDate":"styles_newExpiryDate__1zQIU","footer":"styles_footer__3ec7W"};